module.exports = __webpack_public_path__ + "img/icon-complete.cf41a5ed.svg";